import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddPurchaseOrderLayer from "../components/AddPurchaseOrderLayer";

const AddPurchaseOrderPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Add Purchase Order" />
        <AddPurchaseOrderLayer />
      </MasterLayout>
    </>
  );
};

export default AddPurchaseOrderPage;
